import { Icon } from "@chakra-ui/react"
import { forwardRef, LegacyRef } from "react"
import { FaVideoSlash } from "react-icons/fa"
import { DropdownItem } from "src/components/common/dropdown/dropdown.interfaces"
import {
  DevicesLists,
  TDeviceTypes
} from "src/components/settings/settings.interfaces"
import {
  Video,
  VideoContainer,
  VideoWrapper
} from "src/components/settings/settings.styled"
import { SettingCamera } from "src/components/settings/settingsCamera"
import useConfig from "src/hooks/useConfig"
import { RoomBranding } from "src/recoil/atoms/room/types"
import { AtomSettingsMuteType } from "src/recoil/atoms/settings/types"

type Props = {
  roomStyles: RoomBranding
  isShowFullView: boolean
  currentMutedDevices: AtomSettingsMuteType
  handleChangeDevice: (type: TDeviceTypes, device: DropdownItem) => void
  currentVideo: DropdownItem
  handleChangeMuteDevice: (type: TDeviceTypes, isMuted: boolean) => void
  devicesLists: DevicesLists
  tracks: any
  isHomePage: boolean
  сolorBorder: string
  devicePermissionDenied: { audio: boolean; video: boolean }
  wrapperWidth: string
  isSmallView: boolean
}

const ConditionalSettingsCamera = forwardRef(
  (
    {
      roomStyles,
      isShowFullView,
      currentMutedDevices,
      handleChangeDevice,
      currentVideo,
      handleChangeMuteDevice,
      devicesLists,
      tracks,
      isHomePage,
      сolorBorder,
      devicePermissionDenied,
      wrapperWidth,
      isSmallView
    }: Props,
    ref: LegacyRef<HTMLDivElement>
  ) => {
    const { localCamEnabled } = useConfig()
    if (!localCamEnabled) return null

    return (
      <>
        <SettingCamera
          roomStyles={roomStyles}
          isShowFullView={isShowFullView}
          currentMutedDevices={currentMutedDevices}
          handleChangeDevice={handleChangeDevice}
          currentVideo={currentVideo}
          handleChangeMuteDevice={handleChangeMuteDevice}
          devicesLists={devicesLists}
          videoTrack={tracks.video}
          isHomePage={isHomePage}
          сolorBorder={сolorBorder}
          devicePermissionDenied={devicePermissionDenied}
        />
        <VideoWrapper
          wrapperWidth={wrapperWidth}
          isSmallView={isSmallView && !isHomePage}
        >
          <Video
            сolorBorder={сolorBorder}
            isHomePage={isHomePage}
            roomStyles={roomStyles}
          >
            {currentMutedDevices?.video === true && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  borderRadius: "50%",
                  zIndex: 10,
                  opacity: 0.5,
                  padding: "10px",
                  transform: "translate(-50%, -50%)",
                  background: roomStyles?.joinButtonBackgroundColor || "#1AC541"
                }}
              >
                <Icon
                  src={FaVideoSlash}
                  display="flex"
                  color={roomStyles?.joinPageButtonTextColor || "#FFFFFF"}
                  fontSize={isSmallView && !isHomePage ? "2rem" : "3rem"}
                />
              </div>
            )}
            <VideoContainer
              isCamMuted={currentMutedDevices?.video}
              roomStyles={roomStyles}
              ref={ref}
            />
          </Video>
        </VideoWrapper>
      </>
    )
  }
)

export default ConditionalSettingsCamera
